<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>定制明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">定制明细</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="定制">
                  <el-select
                    v-model="ruleForm.name"
                    placeholder="请选择定制"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.lvKey"
                      v-for="(item, index) in tableData"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData1" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="propDesc" label="定制图标" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.propDesc.icon"
                alt=""
                style="width: 50px; height: 50px"
            /></template>
          </el-table-column>
          <el-table-column prop="propDesc" label="定制名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.propDesc.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="propDesc" label="定制值" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.propValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="介绍" align="center" prop="propValue">
            <template slot-scope="scope">
              <span>{{ scope.row.propDesc.subTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column label="排序" align="center" prop="sort">
          </el-table-column>
          <el-table-column label="是否显示" align="center" prop="sort">
            <template slot-scope="scope">
              <span class="greenColor" v-if="scope.row.display == 1">是</span>
              <span class="redColor" v-if="scope.row.display == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination> -->
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="定制图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="deader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              v-if="ruleForm1.icon"
              :src="ruleForm1.icon"
              class="avatar"
              style="width: 100px"
            />
            <div class="modelView1" v-if="ruleForm1.icon">编辑</div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="定制名称" prop="title">
          <el-input
            v-model="ruleForm1.title"
            placeholder="请输入定制名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="定制值" prop="num">
          <el-input
            v-model="ruleForm1.num"
            placeholder="请输入定制值"
          ></el-input>
        </el-form-item>
        <el-form-item label="定制介绍" prop="subTitle">
          <el-input
            v-model="ruleForm1.subTitle"
            placeholder="请输入定制介绍"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="ruleForm1.sort"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否显示"
          prop="sort"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.display">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
    Template,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      tableData1: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: "",
      ruleForm1: {
        sort: "",
        num: "",
        title: "",
        subTitle: "",
        icon: "",
        display: "1", // 默认显示
      },
      rules: {
        icon: [{ required: true, message: "必选项", trigger: "blur" }],
        sort: [{ required: true, message: "必选项", trigger: "blur" }],
        num: [{ required: true, message: "必选项", trigger: "blur" }],
        title: [{ required: true, message: "必选项", trigger: "blur" }],
        subTitle: [{ required: true, message: "必选项", trigger: "blur" }],
      },
      uploadUrl: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
    };
  },
  mounted() {
    this.getData();
    if (this.$route.query.lvKey) {
      this.ruleForm.name = this.$route.query.lvKey;
    }
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.ruleForm1.icon = res.data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            title: this.ruleForm1.title,
            subTitle: this.ruleForm1.subTitle,
            icon: this.ruleForm1.icon,
          };
          let param = {
            propName: this.ruleForm.name,
            propDesc: JSON.stringify(obj),
            propValue: this.ruleForm1.num,
            display: this.ruleForm1.display,
            sort: this.ruleForm1.sort,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/sys/conf/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getList();
              })
              .catch()
              .finally(() => {});
          } else {
            this.$axios
              .post(`/admapi/sys/conf/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getList();
              })
              .catch()
              .finally(() => {});
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.title = "新增定制明细";
      this.editId = "";
      this.ruleForm1.sort = "";
      this.ruleForm1.num = "";
      this.ruleForm1.title = "";
      this.ruleForm1.subTitle = "";
      this.ruleForm1.icon = "";
      this.ruleForm1.display = "1";
      this.dialogFormVisible = true;
    },
    handleEdit(val) {
      this.editId = val.id;
      this.title = "编辑定制明细";
      this.ruleForm1.sort = val.sort;
      this.ruleForm1.num = val.propValue;
      this.ruleForm1.title = val.propDesc.title;
      this.ruleForm1.subTitle = val.propDesc.subTitle;
      this.ruleForm1.icon = val.propDesc.icon;
      this.ruleForm1.display = val.display.toString();
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: this.ruleForm.name,
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            arr[i].propDesc = JSON.parse(arr[i].propDesc);
          }
          this.tableData1 = arr;
        })
        .catch()
        .finally();
    },
    getData() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_customization",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData = JSON.parse(data.items[0].propValue);
          this.getList();
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/sys/conf/del`, {
              id: val.id,
              propName: this.ruleForm.name,
            })
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
